module.exports = __webpack_public_path__ + "static/media/crwn.1c8ef8a5.webp";